if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.warn = () => {};
}

import React, { useEffect, useState, createContext } from "react";
import { loadCartFromStorage, loadFromStorage, saveCartToStorage } from "./utils/cartStorage";
import Cart from "./Cart";
import TopNav from "./TopNav";
import CheckoutPage from "./CheckoutPage";
import PaymentPage from "./PaymentPage";
import OrderConfirmation from "./OrderConfirmation";
import { createPortal } from 'react-dom';
import Content from "./Content";

import {
  BrowserRouter as Router,
  Route,
  Routes,
  useParams,
  // useSearchParams 
} from "react-router-dom";
import axios from "axios";

axios.defaults.withCredentials = true;

export const PopupContext = createContext();

function CartLink({ cart /*, isActive*/ }) {
  if (cart.length === 0) return null;

  const container = document.getElementById('cart-link-container');
  if (!container) return null;

  return createPortal(
    <a href="/cart">
      {/* className={isActive("/cart")}> */}
      <span className="cart-link">

        <span className="label-text">
          {/* 🛒 */}
          <svg viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M36 4
                H32
                V20
                H8
                L0 6"
              stroke="white"
              strokeWidth="4"
              fill="none"
              strokeLinejoin="round"
              strokeLinecap="round"
            />
            <circle cx="13" cy="26" r="4" fill="white" />
            <circle cx="28" cy="26" r="4" fill="white" />
          </svg>{cart.length > 0 ? ` (${cart.length})` : ''}
        </span>
      </span>
    </a>,
    container
  );
}

function Home(cart) {
  return (
    <div className="pane pane-center">
      <div className="left_right_container">
        <div className="left">
          <div className="dark_pane text_pane">
            <img src="media/venom-small.png" alt="venom-logo-small" />
            <p>
              Designed for goalkeepers at every level,
              the MFK Venom gloves provide outstanding grip and comfort.
              Featuring a hybrid cut with rolled thumb and fingers,
              they deliver a secure fit and superior ball handling.
              Perfect for both training sessions and competitive matches.
            </p>
          </div>
        </div>
        <div className="right">
          <picture>
          <source srcset="media/glove-web-small.png" media="(max-width: 768px)" />
          <source srcset="media/glove-web.png" />
 
          <img src="media/glove-web.png" alt="MFK Venom glove" />
          </picture>
        </div>
      </div>
    </div>
  );
}

function AboutUs(cart) {
  return (
    // was: <div className="pane pane-center">
    <div className="pane pane-center dark_pane">
      <div className="left_right_container">
        <div className="left">

          {/* was: <div className="text_pane dark_pane"> */}
          <div className="text_pane">
            <h2>About us</h2>
            <p>
              <a href="/">Made for Keepers</a> is created by goalkeepers, for goalkeepers.
              Born from our own relentless pursuit of top-tier gear to perform at the highest level,
              we're dedicated to bringing that same standard to keepers around the world.
              Whether you're stepping onto the pitch for the first time or playing at the elite level,
              our mission is simple: to equip you with the best—because we know what it takes.
            </p>
            <hr />
            <h2>Important information</h2>
            <ul>
              <li><a href="/content/terms-and-conditions">Terms &amp; conditions</a></li>
              <li><a href="/content/privacy-policy">Privacy policy</a></li>
            </ul>
          </div>
        </div>
        <div className="right">
          <picture>
            <source srcset="media/glove-web-small.png" media="(max-width: 768px)" />
            <source srcset="media/glove-web.png" />

            <img src="media/glove-web.png" alt="MFK Venom glove" />
          </picture>
        </div>
      </div>
    </div>
  );
}

function Contact(cart) {
  const [formState, setFormState] = useState('to-be-sent');
  const [notifyEmail, setNotifyEmail] = useState('');
  const [message, setMessage] = useState('');
  const [companyInfo, setCompanyInfo] = useState(null);

  useEffect(() => {
    async function fetchCompanyInfo() {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/company_info`);
        setCompanyInfo(res.data);
      } catch (err) {
        console.error("Error fetching company info:", err);
      }
    }
    fetchCompanyInfo();
  }, []);

  const handleNotifySubmit = async (e) => {
    e.preventDefault();

    if (!notifyEmail || !message) return;

    const csrfResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`, {
      credentials: "include" // crucial for cookies
    });
    const csrfData = await csrfResponse.json();

    console.log("Token: " + csrfData.csrfToken);
    const csrfToken = csrfData.csrfToken;

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/contact`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "CSRF-Token": csrfToken },
        credentials: "include",
        body: JSON.stringify({
          email: notifyEmail,
          message: message
        })
      });

      if (!res.ok) throw new Error('API error');

      setNotifyEmail('');
      setFormState('sent');
    } catch (err) {
      console.error('Notification request failed:', err);
      // Optionally show error message
    }
  };

  return (
    <div className="pane pane-center dark_pane">
      <div className="left_right_container">
        <div className="left">
          <h2>Contact us</h2>
          {(formState == 'to-be-sent') && (
            <>
              <p>
                Please enter your message below. We will respond as soon as possible.
              </p>
              <form onSubmit={handleNotifySubmit}>
                <div className="form-group">
                  <input
                    type="email"
                    required
                    placeholder="Enter your email"
                    value={notifyEmail}
                    onChange={e => setNotifyEmail(e.target.value)}
                  />
                </div>
                <div className="form-group">
                  <textarea
                    required
                    placeholder="Enter your message here..."
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                    aria-multiline="true" />
                </div>
                <div className="form-group">
                  <button type="submit">Send</button>
                </div>
              </form>
            </>

          )}
          {(formState == 'sent') && (
            <>
              <p>
                Thanks for contacting us! We will respond as soon as possible.
              </p>
            </>
          )}
        </div>
        {companyInfo && (
          <div className="right">
            <h2>Headquarters</h2>
            <label>Address:</label><span>
              {companyInfo.name}<br />
              {companyInfo.address.split('\n').map((line, i) => (
                <span key={i}>{line}<br /></span>
              ))}
            </span><br />
            <label>General:</label><span>
              <a href={`mailto:${companyInfo.infoMailAddress}`}>{companyInfo.infoMailAddress}</a><br />
            </span>
            <label>Support:</label><span>
              <a href={`mailto:${companyInfo.supportMailAddress}`}>{companyInfo.supportMailAddress}</a><br />
            </span>

          </div>)}
      </div>
    </div>
  );
}

function PaymentComplete(cart) {
  const [lastOrderId] = useState(loadFromStorage("lastOrderId", "UNKNOWN"));
  const [lastOrder, setLastOrder] = useState(null);
  // let orderState = "UNKNOWN";

  useEffect(() => {
    if (!lastOrderId) {
      return;
    }

    let attempts = 0;
    const maxAttempts = 10;

    const interval = setInterval(async () => {
      if (attempts >= maxAttempts) {
        console.warn("Max retries reached");
        clearInterval(interval);
        return;
      }

      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/order-by-nr/${lastOrderId}`);
        const order = res.data;
        setLastOrder(order);

        if (order.status !== "pending" && order.status !== "UNKNOWN") {
          clearInterval(interval);
        }
      } catch (err) {
        console.error("Failed to fetch order:", err?.response?.data || err.message);
        clearInterval(interval);
      }

      attempts += 1;
    }, 500);

    return () => clearInterval(interval);
  }, [lastOrderId]);

  const orderState = lastOrder?.status || "UNKNOWN";

  if (orderState === "UNKNOWN") {
    return (
      <div className="pane pane-center">
        <div className="left">
          <div className="dark_pane text_pane">
            <img src="media/venom-small.png" alt="venom-logo-small" />
            <p>
              Loading your payment state...
            </p>
          </div>
        </div>
        <div className="right"><img src="media/glove-web.png" alt="MFK Venom glove" /></div>
      </div>
    );
  }

  let message = "";
  switch (orderState) {
    case "succeeded":
    case "paid":
      message = "You will be informed via mail about the delivery of your order.";
      break;
    case "failed":
      message = "Something went wrong. Please contact <a href=\"mailto:support@made-for-keepers.com\">support</a>.";
      break;
    case "pending":
      message = "Please wait while we confirm your payment.";
      break;
    default:
      message = "";
  }

  return (
    <div className="pane pane-center">
      <div className="left_right_container">
        <div className="left">
          <div className="dark_pane text_pane">
            <img src="media/venom-small.png" alt="venom-logo-small" />
            <p>
              Your payment state is {orderState}.
            </p>
            {message && <p dangerouslySetInnerHTML={{ __html: message }} />}
          </div>
        </div>
        <div className="right">
          <picture>
            <source srcset="media/glove-web-small.png" media="(max-width: 768px)" />
            <source srcset="media/glove-web.png" />

            <img src="media/glove-web.png" alt="MFK Venom glove" />
          </picture>
        </div>
      </div>
    </div>
  );
}

function GloveFeatures(cart) {
  return (
    <div className="pane dark_pane lef">
      <div className="left_right_container">
        <div className="left">
          <img src="media/venom-small.png" alt="MFK Venom premium goalkeepers glove, backhand features" /><br />
          <picture>
            <source srcset="media/glove-features-palm-mobile.png" media="(max-width: 768px)" />
            <source srcset="media/glove-features-palm.png" />
            <img src="media/glove-features-palm.png" alt="features palm" />
          </picture>
        </div>
        <div className="right">
          <picture>
            <source srcset="media/glove-features-backhand-mobile.png" media="(max-width: 768px)" />
            <source srcset="media/glove-features-backhand.png" />
            <img src="media/glove-features-backhand.png" alt="features palm" />
          </picture>

        </div>
      </div>
    </div>
  );
}

function ProductList({ addToCart, customAlert, popupState, setPopupState }) {
  const [products, setProducts] = useState([]);
  const [selections, setSelections] = useState({});
  const [notifyEmail, setNotifyEmail] = useState('');

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/products`).then(res => {
      console.log("API response:", res.data);
      setProducts(res.data);
      const initialSelections = {};
      res.data.forEach(product => {
        initialSelections[product._id] = { quantity: 1 };
      });
      setSelections(initialSelections);
    });
  }, []);

  const handleAdd = (product) => {
    const sel = selections[product._id];

    if (!sel?.size || !sel?.quantity) {
      customAlert('Please select size and quantity...');
      return;
    }


    addToCart(product, sel);

    console.log("Showing popup"); // debugging
    setPopupState({ type: 'cart' });
    setTimeout(() => setPopupState(null), 3000);
  };

  const handleChange = (productId, field, value) => {
    setSelections(prev => {
      const current = prev[productId] || {};
      let updated = { ...current, [field]: value };

      // If size is changed, clamp quantity
      if (field === 'size') {
        const selectedSize = value;
        const stock = products
          .find(p => p._id === productId)
          ?.sizes.find(s => s.size === selectedSize)?.numberInStock || 1;
        const maxQty = Math.min(9, stock);
        const currentQty = current.quantity || 1;

        updated.quantity = Math.min(currentQty, maxQty);
      }

      return {
        ...prev,
        [productId]: updated
      };
    });
  };

  const handleOutOfStock = () => {
    customAlert('The selected size is out of stock!\r\nPlease select another size or send us your mailaddress...');
  }

  const handleNotifySubmit = async (e) => {
    e.preventDefault();

    if (!notifyEmail || !popupState?.productId || !popupState?.size) return;

    const csrfResponse = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/csrf-token`, {
      credentials: "include" // crucial for cookies
    });
    const csrfData = await csrfResponse.json();

    console.log("Token: " + csrfData.csrfToken);
    const csrfToken = csrfData.csrfToken;

    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/notify`, {
        method: 'POST',
        headers: { "Content-Type": "application/json", "CSRF-Token": csrfToken },
        credentials: "include",
        body: JSON.stringify({
          email: notifyEmail,
          productId: popupState.productId,
          size: popupState.size
        })
      });

      if (!res.ok) throw new Error('API error');

      // Optionally show confirmation, reset state
      setNotifyEmail('');
      setPopupState(null);
    } catch (err) {
      console.error('Notification request failed:', err);
      // Optionally show error message
    }
  };

  return (
    <div onClick={() => { if (popupState != null && popupState.type != 'permanentAlert') setPopupState(null) }}>
      <script src="Scripts/jquery-3.7.1.min.js" type="text/javascript"></script>
      <script src="script/shop.js" type="text/javascript" key={'shopscript'}></script>
      <div className="pane dark_pane">
        {products.map(product => (
          <div className="left_right_container" key={`product-container-${product._id}`}>
            <div className="left">
              <img src="media/venom-small.png" alt="Venom Glove" />
              <p className="large-img-container">
                <img id="large-img-container"
                  src={product.images.find(i => i._id === product.mainImageId)?.url}
                  alt={product.images.find(i => i._id === product.mainImageId)?.altText} />
              </p>
              <p className="detail-icon-container">
                {product.images.map((img, idx) => (
                  <img
                    key={`product-img-${product._id}_${idx}`}
                    className="thumb"
                    src={img.iconUrl}
                    data-large={img.url}
                    alt={img.altText}
                    onClick={(e) => {
                      const largeImg = document.getElementById("large-img-container");
                      if (largeImg) {
                        largeImg.src = img.url;
                        largeImg.alt = img.altText;
                      }
                    }}
                  />
                ))}
              </p>
            </div>
            <div className="right">
              <img src="media/mfk-venom-logo-large.png" alt="venom logo" />
              <div className="price">
                &euro;{product.price.toFixed(2)}
                {product.hasActiveDiscount && <sup>*)</sup>}
              </div>
              <div className="product-rice">
                {product.hasActiveDiscount && (
                  <>
                    <div className="discount-badge">
                      -{Math.round((product.discount / product.storedPrice) * 100)}%
                    </div>
                    <span className={product.hasActiveDiscount ? "old-price" : ""}>
                      €{product.storedPrice.toFixed(2)}
                    </span>
                    <span className="new-price">
                      €{product.price.toFixed(2)}
                    </span>
                    <p className="note">
                      <sup>*)</sup> Discount valid until{" "}
                      {new Date(product.discountUntil).toLocaleDateString()}
                    </p>
                  </>
                )}
              </div>
              <form>
                <div className="form-group">
                  <label>Size</label>
                  <div className="radio-options radio-group">
                    {product.sizes.filter(s => s.isActive).map(size => (
                      <div key={`size-container-${product._id}-${size.size}`}>
                        <input type="radio"
                          id={`size${size.size}`}
                          name="size"
                          value={size.size}
                          disabled={size.numberInStock <= 0}
                          checked={selections[product._id]?.size === size.size}
                          onChange={() => handleChange(product._id, 'size', size.size)} />
                        {size.numberInStock <= 0 ? (
                          <label
                            className="radio-label"
                            htmlFor={`size${size.size}`}>
                            <span title={`${size.numberInStock} in stock`} onClick={() => handleOutOfStock()}>{size.size}</span>
                          </label>
                          // <div >Out of stock</div>
                        ) : (<label className="radio-label" title={`${size.numberInStock} in stock`} htmlFor={`size${size.size}`}><span>{size.size}</span></label>)}
                      </div>
                    ))}
                  </div>
                </div>
                <div className="form-group">
                  <label htmlFor={`qty-${product._id}`}>Quantity</label>
                  <span className="quantity-selector">
                    <button className="qty-btn decrease"
                      type="button"
                      onClick={() => {
                        const selectedSize = selections[product._id]?.size;
                        if (!selectedSize) {
                          customAlert("Please select a size first!");
                          return;
                        }
                        handleChange(product._id, 'quantity', Math.max(1, (selections[product._id]?.quantity || 1) - 1));
                      }}>−</button>
                    <input
                      id={`qty-${product._id}`}
                      type="number"
                      min="1"
                      max={Math.min(9, product.sizes.find(s => s.size === selections[product._id]?.size)?.numberInStock || 1)}
                      value={selections[product._id]?.quantity || 1}
                      onChange={e => handleChange(product._id, 'quantity', parseInt(e.target.value) || 1)}
                      name={`qty-${product._id}`} className="qty-input" />
                    <button className="qty-btn increase"
                      type="button"
                      onClick={() => {
                        const selectedSize = selections[product._id]?.size;
                        if (!selectedSize) {
                          customAlert("Please select a size first!");
                          return;
                        }
                        const stock = product.sizes.find(s => s.size === selectedSize)?.numberInStock || 1;
                        const maxQty = Math.min(9, stock);
                        const currentQty = selections[product._id]?.quantity || 1;
                        handleChange(product._id, 'quantity', Math.min(maxQty, currentQty + 1));
                      }}>+</button>
                  </span>
                </div>
                <div className="form-group">
                  <label>Size Table</label>
                  <button className="size-btn"
                    onClick={() => setPopupState({ type: 'size-table', sizes: product.sizes })}
                    type="button">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect x="2" y="4" width="20" height="16" rx="2" ry="2" stroke="black" strokeWidth="2" fill="none" />
                      <line x1="2" y1="10" x2="22" y2="10" stroke="black" strokeWidth="2" />
                      <line x1="8" y1="4" x2="8" y2="20" stroke="black" strokeWidth="2" />
                      <line x1="16" y1="4" x2="16" y2="20" stroke="black" strokeWidth="2" />
                      <path d="M4 2 L4 4 M8 2 L8 4 M12 2 L12 4 M16 2 L16 4 M20 2 L20 4" stroke="black" strokeWidth="1" />
                    </svg>
                  </button>
                </div>

                {/* Optional texts to be displayed when 1 or more sizes are out of stock */}
                {product.sizes.filter(s => s.isActive && s.numberInStock <= 0).length === 1 ? (
                  <div className="form-group">
                    <p>Size {product.sizes.filter(s => s.isActive && s.numberInStock <= 0)[0].size} is out of stock...</p>
                  </div>
                ) : (product.sizes.filter(s => s.isActive && s.numberInStock <= 0).length > 1 && (
                  <div className="form-group">
                    <p>Sizes {product.sizes.filter(s => s.isActive && s.numberInStock <= 0).map(size => size.size).join(", ").replace(/, ([^,]*)$/, ' and $1')} are out of stock...</p>
                  </div>
                ))}

                {product.sizes.filter(s => s.isActive && s.numberInStock <= 0).map(size => (
                  <div className="form-group">
                    <button type="button" onClick={() => setPopupState({ type: 'notify', productId: product._id, size: size.size })}>Preorder size {size.size}</button>
                  </div>
                ))}

                <div className="form-group">
                  {/* <label for="add-to-cart"></label> */}
                  <button
                    id="add-to-cart"
                    type="button"
                    onClick={() => handleAdd(product)}
                    className="add">Add to cart</button>
                </div>
              </form>
            </div>
          </div>
        ))}
      </div>
      {popupState?.type === 'cart' && (
        <div className="product-popup">
          <p>Product added to cart</p>
          <div className="popup-buttons">
            <button onClick={() => setPopupState(null)}>Continue Shopping</button>
            <a href="/cart"><button>Go to Cart</button></a>
          </div>
        </div>
      )}
      {/* {popupState?.type === 'alert' && (
        <div className="product-popup">
          <p>{popupState.message}</p>
          <div className="popup-buttons">
            <button onClick={() => setPopupState(null)}>Ok</button>
          </div>
        </div>
      )} */}
      {popupState?.type === 'size-table' && (
        // <div className="product-popup-wrapper">
        <div className="product-popup-scrolling">
          <h2>Size table</h2>
          <div className="left_right_container">
            <div className="left">
              <img src="/media/sizing picture-web-small.png" alt />
            </div>
            <div>
              <table className="size-table">
                <thead>
                  <tr>
                    <th>Size</th>
                    <th>Length (cm)</th>
                  </tr>
                </thead>
                <tbody>
                  {popupState.sizes.map(size => (
                    <tr>
                      <td>{size.size}</td>
                      <td>{size.lengthInCm}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
          <div className="popup-buttons">
            <button onClick={() => setPopupState(null)}>Close</button>
          </div>
        </div>
        // </div>
      )}
      {popupState?.type === 'notify' && (
        // <div className="popup-overlay">
        <div className="product-popup"  onClick={e => e.stopPropagation()}>
          <div className="popup-content">
            <h3>Notify me when size {popupState.size} is back</h3>
            <form onSubmit={handleNotifySubmit}>
              <input
                type="email"
                required
                placeholder="Enter your email"
                value={notifyEmail}
                onChange={e => setNotifyEmail(e.target.value)}
              />
              <input type="hidden" value={popupState.size} />
              <button type="submit">Notify me</button>
              <button type="button" onClick={() => setPopupState(null)}>Cancel</button>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}

function OrderStatus(cart) {
  const { id } = useParams();
  // const [searchParams] = useSearchParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [shippingCostInfo, setShippingCostInfo] = useState(null);

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/orders/${id}`);
        setOrder(res.data);
      } catch (err) {
        console.error("Failed to fetch order", err);
      } finally {
        setLoading(false);
      }
    };

    const fetchShippingCostInfo = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/shippingcostInfo`);
        setShippingCostInfo(res.data);
      } catch (err) {
        console.error("Failed to load shipping cost info", err);
        // setError("Could not load shipping information.");
      }
    };

    fetchOrder();
    fetchShippingCostInfo();
  }, [id]);

  if (loading) return <p>Loading...</p>;
  if (!order) return <p>Order not found.</p>;

  if (!shippingCostInfo) {
    return <div>Loading shipping info...</div>;
  }

  const totalExcludingShipping = order.items.reduce((sum, item) => sum + item.price * item.quantity, 0);
  let total = totalExcludingShipping;
  let shippingCosts = 0;

  if (totalExcludingShipping < shippingCostInfo.threshold) {
    total += shippingCostInfo.costs;
    shippingCosts = shippingCostInfo.costs;
  }

  let trackTraceCosts = 0;

  if (order.useTrackAndTrace && parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS) > 0) {
    trackTraceCosts = parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS);
    total += trackTraceCosts;
  }

  //const netTrackTraceCosts = trackTraceCosts / (1 + VAT_RATE);

  const buyerInfo = order.buyerInfo;
  const addressHtml = (buyerInfo.addressLines || []).filter(Boolean).join("<br>");

  return (
    <div>
      <TopNav cart={cart} />
      <div className="pane dark_pane">
        <div className="container">
          <h2>Order Status</h2>
          <p>Order #{order.orderNumber} <br />
            Status: {order.status}</p>
          <p className="h2">Your details:</p>
          <p>
            {/* <strong></strong><br /> */}
            {/* <hr/> */}
            {buyerInfo.name}<br />
            {addressHtml}<br />
            {buyerInfo.zipCode} {buyerInfo.city}<br />
            {buyerInfo.country}
          </p>
          <p className="h2">Order details:</p>
          {/* <p>
                  <strong>Order details:</strong><br />
                  <hr/>
                </p> */}
          <table className="cart-table">
            <thead>
              <tr>
                <th>Product</th>
                <th>Size</th>
                <th>Quantity</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((item, idx) => (
                <tr key={idx}>
                  <td>{item.name}</td>
                  <td>{item.size}</td>
                  <td>{item.quantity}</td>
                  <td>&euro;{(item.price * item.quantity).toFixed(2)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td className="total" colSpan={5}></td>
              </tr>
              <tr>
                <td>Subtotal:</td>
                <td colSpan={2}>&nbsp;</td>
                <td>&euro;{totalExcludingShipping.toFixed(2)}</td>
              </tr>
              <tr>
                <td>Shipping costs:</td>
                <td colSpan={2}>&nbsp;</td>
                <td>&euro;{shippingCosts.toFixed(2)}</td>
              </tr>
              {(order.useTrackAndTrace && parseFloat(process.env.REACT_APP_TRACK_TRACE_COSTS) > 0) && (
                <tr>
                  <td>Track and trace:</td>
                  <td colSpan={2}>&nbsp;</td>
                  <td>&euro;{trackTraceCosts.toFixed(2)}</td>
                </tr>
              )}
              <tr>
                <td className="total" colSpan={5}></td>
              </tr>
              <tr>
                <td>Total:</td>
                <td colSpan={2}>&nbsp;</td>
                <td>&euro;{total.toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );

}

export default function App() {
  const [cart, setCart] = useState(loadCartFromStorage);
  const [popupState, setPopupState] = useState(null);

  useEffect(() => {
    saveCartToStorage(cart);
  }, [cart]);

  const addToCart = (product, selection) => {
    if (!selection?.size || !selection?.quantity) {
      customAlert('Please select size and quantity...');
      return;
    }

    console.log("Adding to cart", product.name);

    setCart(prev => {
      const existingIndex = prev.findIndex(item => item.productId === product._id && item.size === selection.size);
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex].quantity += selection.quantity;
        return updated;
      }
      return [...prev, {
        productId: product._id,
        name: product.name,
        price: product.price,
        size: selection.size,
        mainImageId: product.mainImageId,
        images: product.images,
        quantity: selection.quantity
      }];
    });
  };

  const customAlert = (message) => {
    setPopupState({ type: "alert", message });
    setTimeout(() => setPopupState(null), 3000);
  };
  OrderConfirmation
  const permanentAlert = (message) => {
    setPopupState({ type: "permanentAlert", message });
  };

  return (
    <PopupContext.Provider value={customAlert}>
      <Router>
        <CartLink cart={cart} />
        <TopNav cart={cart} />
        <Routes>
          <Route path="/" element={<Home cart={cart} />} />
          <Route path="/about-us" element={<AboutUs cart={cart} />} />
          <Route path="/contact" element={<Contact cart={cart} />} />
          <Route path="/products" element={<ProductList addToCart={addToCart} customAlert={customAlert} popupState={popupState} setPopupState={setPopupState} />} />
          <Route path="/glove-features" element={<GloveFeatures cart={cart} />} />
          <Route path="/cart" element={<Cart cart={cart} setCart={setCart} />} />
          <Route path="/checkout" element={<CheckoutPage cart={cart} />} />
          <Route path="/payment" element={<PaymentPage cart={cart} />} />
          <Route path="/order-confirmation" element={<OrderConfirmation cart={cart} customAlert={customAlert} permanentAlert={permanentAlert} popupState={popupState} setPopupState={setPopupState} />} />
          <Route path="/order/:id" element={<OrderStatus cart={cart} />} />
          <Route path="/payment-complete" element={<PaymentComplete cart={cart} />} />
          <Route path="/content/:pageKey" element={<Content cart={cart} />} />
          {/* catch-all → /content/404 */}
          {/* <Route path="*" element={<Content404 cart={cart} />} />    */}
          <Route path="*" element={<Content cart={cart} />} />
        </Routes>

        {(popupState?.type === "alert") && (
          <div className="product-popup">
            <p>{popupState.message}</p>
            <div className="popup-buttons">
              <button onClick={() => setPopupState(null)}>Ok</button>
            </div>
          </div>
        )}
        {(popupState?.type === "permanentAlert") && (
          <div className="popup-bg">
            <div className="product-popup">
              <p>{popupState.message}</p>
            </div>
          </div>
        )}
      </Router>
    </PopupContext.Provider>
  );
}

// export default App;
